import screenbanner from "./images/background/1.jpg";
import mobilebanner from "./images/background/2.jpg";

import urbanresort from './images/property/urbanresort.webp'
import capital from './images/property/capital.webp'
import crown from './images/property/crown.webp'
import mansion from './images/property/Mansion.webp'
import smartworld from './images/property/onedxp.webp'
import max from "./images/property/max.webp"


export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};

export const LocationData = {
  taglineheading: "Property In Dwarka Expressway Gurugram",
  locationtag: "",
  location: [
    {
      name: "Whiteland - Urban Resort",
      image: urbanresort,
      price: "On Request",
      location: "Sector 103",
      
      bed: "1 - 3 BHK",
      size: "....",
      url: `/whiteland-urban-resort`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Godrej - Vriksha",
      image: urbanresort,
      price: "On Request",
      location: "Sector 103",
      bed: "3 - 4 BHK",
      size: "....",
      url: `/whiteland-urban-resort`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Sobha - Altus",
      image: urbanresort,
      price: "On Request",
      location: "Sector 106",
      projectlocation:"Dwarka Expressway",
      bed: "4 - 5 BHK",
      size: "....",
      url: `/sobha-sector-63`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "M3M - Crown",
      image: crown,
      price: "On Request",
      location: "Sector 111",
      projectlocation:"Dwarka Expressway",
      bed: "3 - 4 BHK",
      size: "....",
      url: `/m3m-crown`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Smartworld - One DXP",
      image: smartworld,
      price: "On Request",
      location: "Sector  113",
      bed: "2 - 4 BHK ",
      size: "....",
      url: `/smartworld-one-dxp`,
      projectlocation:"Dwarka Expressway",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "M3M - Mansion",
      image: mansion,
      price: "On Request",
      location: "Sector 113",
      bed: "3 - 5 BHK ",
      size: "....",
      url: `/m3m-mansion`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "M3M - Capital",
      image: capital,
      price: "On Request",
      location: "Sector 113",
      bed: "2 - 4 BHK ",
      size: "....",
      url: `/m3m-capital`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Krisumi - Krisumi Waterside",
      image: urbanresort,
      price: "On Request",
      location: "Sector 36A",
      bed: "2 - 4 BHK ",
      size: "....",
      url: `/m3m-capital`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Max - Estate 360",
      image: max,
      price: "On Request",
      location: "Sector 36A",
      bed: "3 - 4 BHK ",
      size: "....",
      url: `/m3m-capital`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "BPTP - The Amaario",
      image: urbanresort,
      price: "On Request",
      location: "Sector 37D",
      bed: "4 BHK ",
      size: "....",
      url: `/m3m-capital`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};